import React, { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';
import { t, getLocale } from './i18n';
import { PostariPeTaburi } from './PaginaClient';
import { extrageTextDinWord } from './aiCompositor';
import { BandaRapoarte } from './Raport';

// ============================================================
// Acasa si Profilul de voce (16 septembrie 2026, cerute de Luminita; ACASA_PLAN.md).
//
// Acasa (super_admin si manager): imaginea de ansamblu pe TOTI clientii — clientii,
// cu poza si ce au de aprobat, apoi postarile tuturor pe tab-uri, cu numele clientului
// pe fiecare rand. Cand se intra pe Acasa, clientul ales se sterge: Calendar, Inbox,
// De aprobat, Aprobate, Echipa si Biblioteca arata toti clientii; Analize nu apare.
//
// Profilul de voce: pagina separata, cu textul de citit si de modificat (decizia 4a:
// buton Salveaza + data ultimei modificari). Inainte profilul se putea doar inlocui cu
// un Word sau sterge, fara sa-l poti citi. Motorul de texte citeste `continut` la
// fiecare generare, deci ce se salveaza aici se foloseste de la urmatoarea generare.
// ============================================================

export function PaginaAcasa({ clienti = [], postari = [], retele, statusInfo, iconRetea, deschideGrup, deschideClient, onStergeGrup = null }) {
  const [poze, setPoze] = useState({});
  const idClienti = clienti.map(c => c.id).join(',');

  // Poza clientului = prima poza de cont (a Paginii de Facebook, cand exista), ca in lista de clienti.
  useEffect(() => {
    let activ = true;
    (async () => {
      const rezultat = {};
      await Promise.all(clienti.map(async c => {
        const { data } = await supabase.rpc('conturi_client', { p_client_id: c.id });
        const cuPoza = (data || []).filter(r => r.poza_url);
        const fb = cuPoza.find(r => r.platform === 'facebook');
        rezultat[c.id] = { poza: (fb || cuPoza[0] || {}).poza_url || null, conturi: (data || []).length };
      }));
      if (activ) setPoze(rezultat);
    })();
    return () => { activ = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idClienti]);

  const ids = new Set(clienti.map(c => c.id));
  const postariClienti = postari.filter(p => ids.has(p.clientId));

  return (
    <div className="pagina">
      {/* Rapoartele lunare gata (etapa 7, bucata 7): doar super adminul le vede. */}
      <BandaRapoarte />
      <div className="pagina-header">
        <div>
          <h1 className="pagina-titlu">{t('acasa', 'titlu')}</h1>
          <p className="pagina-subtitlu">{t('acasa', 'subtitlu', { n: clienti.length })}</p>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 12, marginBottom: 28 }}>
        {clienti.map(c => {
          const deAprobat = postariClienti.filter(p => p.clientId === c.id && ['aprobare_finala', 'intern'].includes(p.status)).length;
          const aprobate = postariClienti.filter(p => p.clientId === c.id && p.status === 'aprobat').length;
          const info = poze[c.id] || {};
          return (
            <button
              key={c.id}
              type="button"
              onClick={() => deschideClient(c)}
              style={{ display: 'flex', alignItems: 'center', gap: 12, textAlign: 'left', background: 'white', border: '1.5px solid #D1E8DA', borderRadius: 12, padding: 14, cursor: 'pointer', fontFamily: "'DM Sans', sans-serif" }}
            >
              <div style={{ width: 44, height: 44, borderRadius: '50%', overflow: 'hidden', flexShrink: 0, background: '#1A6B3C', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 600 }}>
                {info.poza ? <img src={info.poza} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : (c.nume || '?').charAt(0).toUpperCase()}
              </div>
              <div style={{ minWidth: 0 }}>
                <div style={{ fontWeight: 600, color: '#0F3D22', fontSize: 15 }}>{c.nume}</div>
                <div style={{ fontSize: 12.5, color: '#4B5563' }}>
                  {[
                    info.conturi === 0 ? t('acasa', 'faraConturi') : null,
                    deAprobat ? t('acasa', 'nDeAprobat', { n: deAprobat }) : null,
                    aprobate ? t('acasa', 'nAprobate', { n: aprobate }) : null,
                  ].filter(Boolean).join(' · ') || (c.functie || '')}
                </div>
              </div>
            </button>
          );
        })}
      </div>

      <PostariPeTaburi
        postari={postariClienti}
        retele={retele}
        statusInfo={statusInfo}
        iconRetea={iconRetea}
        deschideGrup={deschideGrup}
        arataClient
        onStergeGrup={onStergeGrup}
      />
    </div>
  );
}

export function ProfilVoce({ client }) {
  const [text, setText] = useState('');
  const [original, setOriginal] = useState('');
  const [actualizatLa, setActualizatLa] = useState(null);
  const [stare, setStare] = useState('seIncarca');
  const [mesaj, setMesaj] = useState('');
  // „Vocea in comentarii” (15 oct 2026): fisa scurta pentru ciornele de raspuns.
  const [voceCom, setVoceCom] = useState('');
  const [voceComOriginal, setVoceComOriginal] = useState('');
  const [mesajCom, setMesajCom] = useState('');

  useEffect(() => {
    let activ = true;
    setStare('seIncarca');
    setMesaj('');
    (async () => {
      const { data, error } = await supabase
        .from('profiluri_imagologice')
        .select('continut, actualizat_la, voce_comentarii')
        .eq('client_id', client.id)
        .maybeSingle();
      if (!activ) return;
      if (error) { setStare('eroare'); setMesaj(error.message); return; }
      setText((data && data.continut) || '');
      setOriginal((data && data.continut) || '');
      setActualizatLa(data ? data.actualizat_la : null);
      setVoceCom((data && data.voce_comentarii) || '');
      setVoceComOriginal((data && data.voce_comentarii) || '');
      setStare('gata');
    })();
    return () => { activ = false; };
  }, [client.id]);

  const modificat = text !== original;

  async function salveaza() {
    setStare('seSalveaza');
    setMesaj('');
    const acum = new Date().toISOString();
    const { error } = await supabase
      .from('profiluri_imagologice')
      .upsert({ client_id: client.id, continut: text, actualizat_la: acum }, { onConflict: 'client_id' });
    if (error) { setStare('gata'); setMesaj(t('profilVoce', 'eroareSalvare') + error.message); return; }
    setOriginal(text);
    setActualizatLa(acum);
    setStare('gata');
    setMesaj(t('profilVoce', 'salvat'));
  }

  async function salveazaVoceCom() {
    setMesajCom('');
    const acum = new Date().toISOString();
    const { error } = await supabase.from('profiluri_imagologice')
      .upsert({ client_id: client.id, voce_comentarii: voceCom.trim() || null, voce_comentarii_la: acum }, { onConflict: 'client_id' });
    if (error) { setMesajCom(t('profilVoce', 'eroareSalvare') + error.message); return; }
    setVoceComOriginal(voceCom);
    setMesajCom(t('profilVoce', 'salvat'));
  }

  async function incarcaWord(e) {
    const fisier = e.target.files && e.target.files[0];
    e.target.value = '';
    if (!fisier) return;
    if (modificat && !window.confirm(t('profilVoce', 'confirmaInlocuire'))) return;
    try {
      const continut = await extrageTextDinWord(fisier);
      setText(continut || '');
      setMesaj(t('profilVoce', 'wordIncarcat'));
    } catch (err) {
      setMesaj(t('profilVoce', 'eroareWord') + (err && err.message ? err.message : ''));
    }
  }

  const dataFmt = actualizatLa
    ? new Date(actualizatLa).toLocaleString(getLocale(), { timeZone: 'Europe/Bucharest', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    : null;

  return (
    <div className="pagina">
      <div className="pagina-header">
        <div>
          <h1 className="pagina-titlu">{t('profilVoce', 'titlu')}</h1>
          <p className="pagina-subtitlu">
            {dataFmt ? t('profilVoce', 'actualizat', { data: dataFmt }) : t('profilVoce', 'faraProfil')}
            {' · '}{t('profilVoce', 'caractere', { n: text.length })}
          </p>
        </div>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          <label className="btn-secundar" style={{ cursor: 'pointer' }}>
            <input type="file" accept=".doc,.docx" onChange={incarcaWord} style={{ display: 'none' }} />
            {t('profilVoce', 'incarcaWord')}
          </label>
          <button type="button" className="btn-principal" disabled={!modificat || stare !== 'gata'} onClick={salveaza}>
            {stare === 'seSalveaza' ? t('profilVoce', 'seSalveaza') : t('profilVoce', 'salveaza')}
          </button>
        </div>
      </div>
      <p style={{ fontSize: 13, color: '#374151', marginTop: 0 }}>{t('profilVoce', 'explicatie')}</p>
      {modificat && <p style={{ fontSize: 13, color: '#B45309', margin: '0 0 8px' }}>{t('profilVoce', 'nesalvat')}</p>}
      {mesaj && <p style={{ fontSize: 13, color: '#1A6B3C', margin: '0 0 8px' }} role="status">{mesaj}</p>}
      {stare === 'seIncarca' ? (
        <p>{t('profilVoce', 'seIncarca')}</p>
      ) : (
        <textarea
          id="profil-voce-text"
          value={text}
          onChange={e => setText(e.target.value)}
          spellCheck={false}
          style={{ width: '100%', minHeight: '65vh', boxSizing: 'border-box', padding: 16, borderRadius: 12, border: '1.5px solid #D1E8DA', fontFamily: "'DM Sans', sans-serif", fontSize: 14.5, lineHeight: 1.6, color: '#1F2937', resize: 'vertical', background: 'white' }}
        />
      )}

      {stare !== 'seIncarca' && (
        <div style={{ marginTop: 24 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
            <h2 style={{ fontFamily: "'DM Serif Display', Georgia, serif", fontSize: 22, color: '#0F3D22', margin: 0 }}>{t('profilVoce', 'comTitlu')}</h2>
            <span style={{ fontSize: 13, color: '#4B5563' }}>{t('profilVoce', 'caractere', { n: voceCom.length })}</span>
            <button type="button" className="btn-principal" style={{ marginLeft: 'auto' }} disabled={voceCom === voceComOriginal} onClick={salveazaVoceCom}>{t('profilVoce', 'salveaza')}</button>
          </div>
          <p style={{ fontSize: 13, color: '#374151', margin: '6px 0 8px' }}>{t('profilVoce', 'comExplicatie')}</p>
          {mesajCom && <p style={{ fontSize: 13, color: '#1A6B3C', margin: '0 0 8px' }} role="status">{mesajCom}</p>}
          <textarea value={voceCom} onChange={e => setVoceCom(e.target.value)} spellCheck={false}
            placeholder={t('profilVoce', 'comGol')}
            style={{ width: '100%', minHeight: 260, boxSizing: 'border-box', padding: 16, borderRadius: 12, border: '1.5px solid #D1E8DA', fontFamily: "'DM Sans', sans-serif", fontSize: 14.5, lineHeight: 1.6, color: '#1F2937', resize: 'vertical', background: 'white' }} />
        </div>
      )}
    </div>
  );
}
